
require("./../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
/** ESLint doesn't like file name.
 * It wants it Camel or Pascal case.
 * We named this file sitemap-html because is the path recommended by SEO team
 * which is https://goat.com/sitemap-html
 */

import { SitemapPage } from 'sitemap-html/components';
import getSitemapData from 'sitemap-html/services/sitemapApi';
import { bugsnag } from 'shared/utils/services/bugsnag';
import { setServerSideTranslations } from 'localization/utils/setServerSideTranslations';

const SitemapHTML = ({ sitemap }) => {
  return <SitemapPage data={sitemap} />;
};

export const getServerSideProps = async ({ locale }) => {
  try {
    const sitemapPromise = await getSitemapData();
    const sitemapData = await sitemapPromise;
    const { sitemap } = sitemapData;
    return {
      props: {
        ...(await setServerSideTranslations({ locale })),
        sitemap,
      },
    };
  } catch (error) {
    bugsnag(error, { context: 'Loading sitemap-html Page' });
    return { notFound: true };
  }
};

export default SitemapHTML;
